import { render, staticRenderFns } from "./LatestArticles.vue?vue&type=template&id=23fa492c&scoped=true"
import script from "./LatestArticles.js?vue&type=script&lang=js&external"
export * from "./LatestArticles.js?vue&type=script&lang=js&external"
import style0 from "./LatestArticles.scss?vue&type=style&index=0&id=23fa492c&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23fa492c",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ArticleTeaser: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/articles/ArticleTeaser/ArticleTeaser.vue').default})
